function SetValidityController() {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.startDate = new Date(ctrl.workspace.start_date);
    // Always set end date to 1.1.2038 (Unix time 2145916800)
    ctrl.endDate = new Date(2145916800000); // 1.1.2038 UTC
    ctrl.optionsMenu = {
      startDateOpened: false,
      endDateOpened: false,
      openStartDatePicker: function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        ctrl.optionsMenu.startDateOpened = true;
        ctrl.optionsMenu.endDateOpened = false;
      },
      openEndDatePicker: function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        ctrl.optionsMenu.startDateOpened = false;
        ctrl.optionsMenu.endDateOpened = true;
      },
      datePickerFormat: 'dd.MM.yyyy',
      dateOptions: {
        startingDay: 1,
        showWeeks: false,
      },
    };    
  };

  ctrl.cancel = () => {
    ctrl.onCancel();
  };

  ctrl.updateDates = () => {
  // Always set end date to 1.1.2038 (Unix time 2145916800)
  ctrl.endDate = DateTime.fromMillis(2145916800000).toFormat('yyyy-MM-dd HH:mm:ss');
    if (ctrl.startDate !== ctrl.workspace.start_date) {
      ctrl.startDate = DateTime.fromJSDate(ctrl.startDate).toFormat('yyyy-MM-dd HH:mm:ss');
    }
  }

  ctrl.submit = () => {
    ctrl.updateDates();
    ctrl.onSubmit({
      $event: {
        mode: ctrl.mode,
        id: ctrl.workspace.id,
        startDate: ctrl.startDate,
        endDate: ctrl.endDate
      },
    });
  };
}

angular
  .module('pis-tool.module')
  .controller('SetValidityController', SetValidityController);
